if (!customElements.get('video-hero-controls')) {
  class VideoHeroControls extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      customElements.whenDefined('video-element').then(() => this.init());
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    init() {
      this.video = this.closest('.video-hero')?.querySelector('video-element');
      this.playButton = this.querySelector('[data-video-action="play"]');
      this.soundButton = this.querySelector('[data-video-action="sound"]');

      if (!this.video || !this.playButton || !this.soundButton) return;

      if (this.video.autoplay && !this.video.hasAttribute('muted')) {
        this.video.setAttribute('muted', '');
      }

      const signal = this.abortController.signal;
      this.playButton.addEventListener('click', this.togglePlayback.bind(this), { signal });
      this.soundButton.addEventListener('click', this.toggleSound.bind(this), { signal });
      this.video.addEventListener('video:play', () => this.updatePlayback(true), { signal });
      this.video.addEventListener('video:pause', () => this.updatePlayback(false), { signal });
      this.video.addEventListener('video:mute', () => this.updateSound(true), { signal });
      this.video.addEventListener('video:unmute', () => this.updateSound(false), { signal });

      this.updatePlayback(this.video.playing);
      this.updateSound(this.video.hasAttribute('muted'));
    }

    togglePlayback() {
      if (this.video.playing) {
        this.video.paused = true;
        this.video.pause();
      } else {
        this.video.paused = false;
        this.video.play();
      }
    }

    toggleSound() {
      this.video.hasAttribute('muted') ? this.video.unmute() : this.video.mute();
    }

    updatePlayback(isPlaying) {
      this.classList.toggle('is-playing', isPlaying);
      this.playButton.setAttribute('aria-pressed', String(isPlaying));
      this.playButton.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
    }

    updateSound(isMuted) {
      this.classList.toggle('is-muted', isMuted);
      this.soundButton.setAttribute('aria-pressed', String(isMuted));
      this.soundButton.setAttribute('aria-label', isMuted ? 'Turn sound on' : 'Mute video');
    }
  }

  customElements.define('video-hero-controls', VideoHeroControls);
}
